import { makeStyles } from '@mui/styles';

import { Link, Typography, Button } from '@mui/material';

import Logo from 'assets/images/webp/logo.webp';
import { useMobile } from 'hooks/useMedia';

// ---------------------------------------------------------------

const MENU = [
  {
    name: 'BROWSE',
    link: '/browse',
  },
  {
    name: 'ANALYTICS',
    link: '/analytics',
  },
  {
    name: 'ABOUT',
    link: '/about',
  },
  {
    name: 'COMMUNITY',
    link: '/community',
  },
];

export default function Header() {
  const classes = useStyles();

  const isMobile = useMobile();

  return (
    <div
      className={classes.container}
      style={{ justifyContent: isMobile ? 'center' : 'space-between' }}
    >
      <Link href="/" underline="none" color="inherit">
        <img src={Logo} alt="Logo" className={classes.logo} />
      </Link>

      {!isMobile && (
        <>
          <div className={classes.menu}>
            {MENU.map(({ name, link }) => (
              <Link href={link} key={name} underline="none" color="inherit">
                <Typography
                  sx={{
                    color: '#001A3C',
                    textTransform: 'uppercase',
                    margin: '0px 23px',
                    fontWeight: 'bold',
                  }}
                >
                  {name}
                </Typography>
              </Link>
            ))}
          </div>

          <div className={classes.right}>
            <Button variant="contained" color="primary">
              Connect Wallet
            </Button>
          </div>
        </>
      )}
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '12px 125px',
  },
  logo: {
    height: 50,
  },
  menu: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
  },
}));
